/* eslint-disable max-len */
import React,{useContext,useEffect,useState} from 'react'
import BannerImage from '../../../components/BannerImage'
import SignIn from './Components/SignIn'
import GlobalContext from '../../../components/Context/GloablContext';
import { Auth } from 'aws-amplify';
import { useDispatch } from 'react-redux';
import { logIn } from '../authSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import TrustBrowser from './Components/TrustBrowser';
import OtpPage from './Components/Otp';
import ForgotPassword from './Components/ForgotPassword';
import SetPreferencesModal from './Components/SetPreferencesModal';
import { userService } from '../../../services/user.services';
import maskValue from '../../../CommonMethods/maskedEmailFunction'
import { handleRestrictKey } from '../../../redux/systemConfigSlice';
import refreshIdToken from '../../../CommonMethods/RefreshIdFunction';
import DuplicateTabCloseModal from './Components/DuplicateTabCloseModal';
import { persistAuthSession, broadcastLogin, setAuthItem } from '../../../CommonMethods/authSession';
import authenticateUser from '../../../config/aws-export';
import { GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
import localStorage from 'redux-persist/lib/storage';
import { getValidatedRedirect } from '../../../CommonMethods/redirectUtils';
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

  
export default function LoginPage() {
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage,setRestrictKey,restrictKey,setIsSideBar,setIsSideBareditSocket,setEditSocket,WebSocketConnection,handleOnClickClearSearch,fetchAndCacheHelpGuides } = useContext(GlobalContext)
    const [IsLoginPage, setIsLoginPage] = useState(true);
    const [loading, setloading] = useState(false);
    const [userData, setuserData] = useState({});
    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const [otp, setOtp] = useState("000000");
    const [timer, setTimer] = useState(30);
    const [duration,setDuration]=useState('')
    const [preferenceLoading, setPreferenceLoading] = useState(false);
    const [isTrustMyBrowser,setIsTrustMyBrowser] = useState(false)

    const [duplicateTabModal, setDuplicateTabModal] = useState(false);
    const [dupLoadingBtn,setDupLoadingBtn]=useState(false);
    const [loginData,setLoginData] = useState('')

    const [displayOtpScreen,setDisplayOtpScreen]=useState(false)
    const [preferenceModel, setPreferenceModel] = useState(false);
    const [preferenceList, setPreferenceList] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState([]);
    const userType = sessionStorage.getItem('user_type')

    const dispatch = useDispatch()
    const [loginCredentials, setloginCredentials] = useState({
        email: '',
        password: ''
    });

    const [error, seterror] = useState(false);
    const [emptyError,setEmptyError]=useState(false)
    const navigate=useNavigate()
    const location = useLocation()
    const [loginError, setloginError] = useState('')
    const { email, password } = loginCredentials
    
    // Clean up redirect parameter from URL when user lands on login page without valid session
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const hasRedirect = searchParams.has('redirect');
        
        // Only clean if on login page, has redirect, and no valid session
        if (hasRedirect && !sessionStorage.getItem('IdToken') && location.pathname === '/') {
            navigate('/', { replace: true });
        }
    }, [location.search, location.pathname, navigate]);
    
    /**
     * Gets the validated redirect path from URL search params.
     * Returns the redirect path if valid, otherwise returns the default path.
     * @param {string} defaultPath - Default path to use if redirect is invalid or missing
     * @returns {string} - Valid redirect path or default path
     */
    const getRedirectPath = (defaultPath) => {
        const searchParams = new URLSearchParams(location.search);
        const redirectPath = getValidatedRedirect(searchParams);
        return redirectPath || defaultPath;
    };

    const handleLoginCredentilas = (key, value) => {
        if(key==="email"){
            setloginCredentials((current) => ({
                ...current,
                [key]: value.replace(/\s/g, '')
            }))

        }else{
            setloginCredentials((current) => ({
                ...current,
                [key]: value
            }))
        }
    }

    const handelClear = () => {
        setloginCredentials({
            email: '',
            password: ''
        });
        setloginError('')
        seterror(false)
    }

    const handleLogin = async (e, key) => {       
        handleOnClickClearSearch()
        seterror(false)
        e.preventDefault();
        if (key === undefined) {
            setloading(true);
            setOtp(Array(6).fill(""))
        }
        if (key) {
            setTimer(parseInt(duration))
        }
        if(email?.trim().replace(/\s/g, '')===""|| password?.trim()===""){
            setEmptyError(true)
            setToastErrorMessage("Please fill in all the mandatory fields")
            setloading(false)
            return
        }
        sessionStorage.setItem('email', email);
        let browser_id = await localStorage.getItem('arcm_trust_browser_token') || '';
        try {
            const loginresponse = await userService.login(email.toLowerCase().trim().replace(/\s/g, ''), password, browser_id);
            setLoginData(loginresponse);
            sessionStorage.setItem('first_name', loginresponse?.data?.first_name);
            sessionStorage.setItem('last_name', loginresponse?.data?.last_name);

            if((loginresponse?.data?.isLoggedIn && loginresponse?.data?.isLoggedIn===true) || (loginresponse?.data?.isLoggedIn && loginresponse?.data?.isLoggedIn===true) ){

                persistAuthSession({
                    email,
                    IdToken: loginresponse?.data?.IdToken,
                    RefreshToken: loginresponse?.data?.RefreshToken,
                    AccessToken: loginresponse?.data?.AccessToken,
                    currentTimestamp: ((new Date).getTime().toString()),
                    user_id: loginresponse?.data?.user_id,
                    id: loginresponse?.data?.id,
                    user_type: loginresponse?.data?.user_access_type,
                    session_token: loginresponse.data.session_token,
                    first_name: loginresponse?.data?.first_name,
                    last_name: loginresponse?.data?.last_name,
                });
                setPreferenceList(loginresponse?.data?.Preference_list)

                if(loginresponse?.data?.restrict!==null){
                    dispatch(handleRestrictKey(loginresponse?.data?.restrict))
                    setIsSideBar(loginresponse?.data?.restrict)
                }

                setloading(false)
                setDuplicateTabModal(true)
                return 
            }
            
            if(loginresponse?.data?.Preference_list && loginresponse.data?.Preference_list?.length > 0) {
                setPreferenceModel(true)
                sessionStorage.setItem('session_token', loginresponse.data.session_token);
                setAuthItem('user_type', loginresponse?.data?.user_access_type);
                setPreferenceList(loginresponse.data.Preference_list)
                setloading(false);
                return
            } else{
                if (loginresponse.error) {
                    seterror(true);
                    setloginError(loginresponse.message.response.data.message)
                    setloading(false);
                } else {
                    persistAuthSession({
                        email,
                        IdToken: loginresponse?.data?.IdToken,
                        RefreshToken: loginresponse?.data?.RefreshToken,
                        AccessToken: loginresponse?.data?.AccessToken,
                        currentTimestamp: ((new Date).getTime().toString()),
                        user_id: loginresponse?.data?.user_id,
                        id: loginresponse?.data?.id,
                        user_type: loginresponse?.data?.user_access_type,
                        first_name: loginresponse?.data?.first_name,
                        last_name: loginresponse?.data?.last_name,
                    });

                    if((loginresponse?.data?.restrict === false && loginresponse?.data?.trust_my_browser === true) || loginresponse?.data?.restrict === false) {
                        // Reset logout flag on successful login
                        if (window.isLoggingOutRef) {
                            window.isLoggingOutRef.current = false;
                        }
                        broadcastLogin();
                        dispatch(logIn());
                        setIsSideBar(false)
                        refreshIdToken()
                        authenticateUser(email.toLowerCase().trim().replace(/\s/g, ''), password)  
                        WebSocketConnection()
                        setInterval(handleRefreshToken, 9 * 60 * 1000);
                        setToastmessage('Login successful')
                        const defaultPath = loginresponse?.data?.user_access_type==='monitor-user' ? '/manage-dashboard' : '/alerts-notifications';
                        const redirectPath = getRedirectPath(defaultPath);
                        // Use requestAnimationFrame to ensure state updates have propagated
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                navigate(redirectPath);
                            });
                        });
                        if(localStorage.getItem('arcm_trust_browser_token') !== null){
                            fetchAndCacheHelpGuides()
                        }
                        return
                    }
                    if(loginresponse?.data?.restrict === "true" || loginresponse?.data?.restrict === true) {
                        // Reset logout flag on successful login
                        if (window.isLoggingOutRef) {
                            window.isLoggingOutRef.current = false;
                        }
                        dispatch(handleRestrictKey(loginresponse?.data?.restrict))
                        setIsSideBar(loginresponse?.data?.restrict)
                        setAuthItem('user_type', loginresponse?.data?.user_access_type);
                        dispatch(logIn());
                        setToastmessage('Login successful')
                        refreshIdToken()
                        setInterval(handleRefreshToken, 9 * 60 * 1000);
                        const redirectPath = getRedirectPath('/profile');
                        // Use requestAnimationFrame to ensure state updates have propagated
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                navigate(redirectPath);
                            });
                        });

                        WebSocketConnection()
                        return
                    }
                    if(loginresponse.data.is_reset_password === false||loginresponse.data.status==='reset') {
                        refreshIdToken()
                        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                        sessionStorage.setItem('custom:is_first_time_login', true);
                        setAuthItem('user_type', loginresponse?.data?.user_access_type);
                        setToastmessage('Login successful')
                        navigate('/reset',{state:{'refresh_interval':intervalId}})
                        return
                    }
                    // setToastmessage('You’ve received an OTP to your registered email address or +91 xxxx-xxxxx')
                    setIsLoginPage(false);
                    setDisplayOtpScreen(true);
                    setloading(false);
                }
            }
        } catch (error) {
            if(error.code==="NotAuthorizedException"){
                setloginError(error.message)
            }
            else{
                setloginError(error.message?.split("error")[1])
            }
            
            seterror(true);
            setloading(false);

        }
    };

    const handleSelectPreference = async (item) => {
        setSelectedPreference(item)
    }

    const handleRefreshToken = async () => {
        if(sessionStorage.getItem('IdToken')){
            refreshIdToken()
        } 
    };

    const handleSendotptoPreference = async () => {
        setPreferenceLoading(true)
        const response = await userService.sendOtptoPreference(selectedPreference._id);
        if(response.error === false) {
            sessionStorage.setItem('verify_otp_session_token', response.data.verify_otp_session_token);
            sessionStorage.setItem('duration', response.data.otp_resend_duration);
            sessionStorage.setItem('preference_id', selectedPreference._id);
            setToastmessage(`You’ve been sent an OTP to ${selectedPreference.otp_preference_mode === 'email' 
                ? maskValue(selectedPreference.preference) 
                : `${selectedPreference?.country_code} ${selectedPreference?.preference?.slice(0, 2) + 
                    '*'.repeat(selectedPreference?.preference?.length - 4) + 
                    selectedPreference?.preference?.slice(-2)}`
            }`)
            setDisplayOtpScreen(true)
            setIsLoginPage(false)
            setPreferenceLoading(false)
            setPreferenceModel(false)
        } else{
            setPreferenceLoading(false)
            setToastErrorMessage(response.message)
        }
    }

    const handleClose = () => {
        setPreferenceModel(false)
        setPreferenceLoading(false)
        setSelectedPreference([])
    }

    // Duplicate tab closing fun below

    const handleAllowDuplicateTabClose = async() => {
                 
        if(loginData?.data?.Preference_list===undefined && loginData?.data?.isLoggedIn===true){
            setDupLoadingBtn(true)

            persistAuthSession({
                email,
                IdToken: loginData?.data?.IdToken,
                RefreshToken: loginData?.data?.RefreshToken,
                AccessToken: loginData?.data?.AccessToken,
                currentTimestamp: ((new Date).getTime().toString()),
                user_id: loginData?.data?.user_id,
                id: loginData?.data?.id,
                user_type: loginData?.data?.user_access_type,
                first_name: loginData?.data?.first_name,
                last_name: loginData?.data?.last_name,
            });

            const response = await userService.DuplicateTabClose('');
            
            if (response?.error === false) {
                if (window.isLoggingOutRef) {
                    window.isLoggingOutRef.current = false;
                }
                // Don't broadcast - full reload will re-initialize session, and Browser A is being logged out
                
                const defaultPath = userType === 'monitor-user' ? '/manage-dashboard' : '/alerts-notifications';
                const redirectPath = getRedirectPath(defaultPath);
                
                // Use full page reload to match Admin app behavior and avoid race conditions
                window.location.href = redirectPath;
            } else {
                setDupLoadingBtn(false);
                setToastErrorMessage('Failed to terminate old session. Please try again.');
            }
        }
        else{
            setDuplicateTabModal(false)
            setPreferenceModel(true) 
        }
    }

    const handleDuplicateModalClose = async() => {
        setPreferenceModel(false)
        setDuplicateTabModal(false)
        const DuplicateTabCancelRes  = await userService.CancelDuplicatelogin('')
    }

    return (
        <> 
            <div className='flex bg-white'>
                {!isTrustMyBrowser&&<BannerImage />}
                {!isForgotPassword  && IsLoginPage && !displayOtpScreen&&!isTrustMyBrowser && <SignIn
                    setIsLoginPage={setIsLoginPage}
                    email={email}
                    emptyError={emptyError}
                    setEmptyError={setEmptyError}
                    handleLoginCredentilas={handleLoginCredentilas}
                    error={error}
                    loginError={loginError}
                    seterror={seterror}
                    password={password}
                    loading={loading}
                    setIsForgotPassword={setIsForgotPassword}
                    handleLogin={handleLogin}
                />}
                {duplicateTabModal &&
                    <DuplicateTabCloseModal
                        tittle={'Duplicate Session?'}
                        buttonName={'Yes'}
                        message={'You are already logged in through another system. Do you want to end the other session and login here?'}
                        handleAllowDuplicateClose={handleAllowDuplicateTabClose}
                        handleClose={handleDuplicateModalClose}
                        dupLoadingBtn={dupLoadingBtn}
                        data_testid={"continue-btn"}
                    />
                }
                {!IsLoginPage && displayOtpScreen&&<OtpPage
                    selectedPreference={selectedPreference}
                    setIsTrustMyBrowser={setIsTrustMyBrowser}
                    setSelectedPreference={setSelectedPreference}
                    setloginCredentials={setloginCredentials}
                    setIsLoginPage={setIsLoginPage}
                    handleLogin={handleLogin}
                    duration={duration}
                    userData={userData}
                    setOtp={setOtp}
                    otp={otp}
                    setIsForgotPassword={setIsForgotPassword}
                    // handelClear={handleClear}
                    displayOtpScreen={displayOtpScreen}
                    setDisplayOtpScreen={setDisplayOtpScreen}
                    setPreferenceModel={setPreferenceModel}
                    preferenceModel={preferenceModel}
                    loginCredentials={loginCredentials}
                    loginData={loginData}    
                />
                }
                {isForgotPassword  && IsLoginPage &&
                    <ForgotPassword
                        setIsForgotPassword={setIsForgotPassword}
                        handelClear={handelClear}
                        email={email}
                        emptyError={emptyError}
                        setEmptyError={setEmptyError}
                        error={error}
                        loginError={loginError}
                        seterror={seterror}
                        loading={loading}
                        setloading={setloading}
                    />}
                {preferenceModel &&
                <SetPreferencesModal
                    tittle={'Verify your Identity'}
                    buttonName={'Send'}
                    message={'Select your preference to receive the verification code'}
                    preferenceList={preferenceList}
                    isDropdownOpen={isDropdownOpen}
                    setIsDropdownOpen={setIsDropdownOpen}
                    handleSelectPreference={handleSelectPreference}
                    handleSendotptoPreference={handleSendotptoPreference}
                    selectedPreference={selectedPreference}
                    handleClose={handleClose}
                    setPreferenceLoading={setPreferenceLoading}
                    preferenceLoading={preferenceLoading}
                />
                }
                {
                    isTrustMyBrowser && 
                    <TrustBrowser 
                        setIsTrustMyBrowser={setIsTrustMyBrowser}/>
                }
            </div>
        </>
    )
}
